<template>
  <div class="detail_board_container management_dialog">
    <el-select
        v-model="year"
        placeholder="请选择"
        :disabled="disabled"
        @change="selectYear"
        id="select"
        class="management_dialog-select"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    <el-tabs :tab-position="tabPosition"  @tab-click="handleClick" v-model="activeValue" style="height: 100%;width: 100%;">
      <el-tab-pane name="1" label="基本信息">
        <el-row :gutter="20" class="info-detail">
        <el-col :span="24">
          <div class="info-detail-block">
            <span>主体类型：</span
            ><span>{{ spaceDetail.enterpriseTypeName }}</span>
            <span style="position: absolute;right: 20px; padding-right: 40px">
           <!--工商认证-->
          <img
            v-if="spaceDetail.officialStatus==2"
            :src="gstbImg"
            alt=""
            style="width: 40px; height: 40px; vertical-align: middle"
        /></span>
          </div>
          <div class="info-detail-block">
            <span>主体等级：</span
            ><span>{{ spaceDetail.gradeName }}</span>
          </div>
          <div class="info-detail-block">
            <span>社会信用代码：</span
            ><span>{{ spaceDetail.unifiedSocialCreditCode }}</span>
          </div>
          <div class="info-detail-block">
            <span>注册资金：</span
            ><span>{{ spaceDetail.registerCapital }}万元</span>
          </div>
          <div class="info-detail-block">
            <span>成立时间：</span><span>{{ formatterDate(spaceDetail.createDate) }}</span>
          </div>
          <div class="info-detail-block">
            <span>法人姓名：</span><span>{{ spaceDetail.corporationName }}</span>
          </div>
          <div class="info-detail-block">
            <span>法人手机号：</span><span>{{ spaceDetail.corporationMobile }}</span>
          </div>
          <div class="info-detail-block">
            <span>注册地址：</span><span>{{ spaceDetail.address }}</span>
          </div>
          <div class="info-detail-block">
            <span>营业执照：</span>
            <div>
              <el-image
                class="info-detail-block-license"
                :src="qualificationImg"
                alt=""
                v-if="qualificationImg"
                :preview-src-list="[qualificationImg]"
              >
              </el-image>
              <span v-else>暂无图片</span>
            </div>
          </div>
        </el-col>
      </el-row>
      </el-tab-pane>
      <el-tab-pane name="2" label="经营情况">
        <el-row class="detail_item" :gutter="20">
            <!-- <div class="detail_name">从事行业：</div> -->
            <div class="detail_content">
              <el-row
                :gutter="20"
                class="detail_content-row"
                v-for="(
                  item, key
                ) in currentEnterprise.enterpriseManageItemVoList"
                :key="key"
              >
                <el-col :span="24" class="space-top" style="color:#000;font-weight: bold;"
                  ><div>{{ item.name }}</div></el-col
                >
                <el-col
                  :span="12"
                  class="space-top"
                  v-for="(t, k) in item.enterpriseManageItemList"
                  :key="k"
                  ><div>
                    <span>{{ t.key }}</span
                    >：<span>{{ t.value ? t.value : 0 }}</span>
                    <span> {{ t.unit }}</span>
                  </div></el-col
                >
              </el-row>
            </div>
          </el-row>
      </el-tab-pane>
      <el-tab-pane name="3" label="组织成员">
        <el-row class="detail_item" :gutter="20">
            <div class="detail_name">组织情况：</div>
            <div class="detail_content">
              <el-row
                type="flex"
                justify="space-between"
                class="detail_content-row"
              >
                <el-col :span="12"
                  ><div>
                    理事会：{{
                      currentEnterprise.enterpriseMember.directorCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
                <el-col :span="12"
                  ><div>
                    监事会：{{
                      currentEnterprise.enterpriseMember.supervisorCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                class="detail_content-row"
              >
                <el-col :span="12"
                  ><div>
                    是否建立党支部：{{
                      filterType(
                        currentEnterprise.enterpriseMember.isCreatePartyBranch
                      )
                    }}
                  </div></el-col
                >
                <el-col :span="12"
                  ><div>
                    其中党员人数：{{
                      currentEnterprise.enterpriseMember.partyMemberCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
              </el-row>
            </div>
          </el-row>
        <el-row class="detail_item" :gutter="20">
            <div class="detail_name">成员情况：</div>
            <div class="detail_content">
              <el-row
                type="flex"
                justify="space-between"
                class="detail_content-row"
              >
              <el-col :span="24"
                  ><div>
                    实有成员总数：{{
                      currentEnterprise.enterpriseMember.realMemberCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                class="detail_content-row"
              >
                <el-col :span="12"
                  ><div>
                    其中普通农户：{{
                      currentEnterprise.enterpriseMember.farmerCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
                <el-col :span="12"
                  ><div>
                    其中家庭农场成员：{{
                      currentEnterprise.enterpriseMember.familyMemberCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                class="detail_content-row"
              >
                <el-col :span="12"
                  ><div>
                    其中企业成员：{{
                      currentEnterprise.enterpriseMember.enterpriseMemberCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
                <el-col :span="12"
                  ><div>
                    其中其他成员：{{
                      currentEnterprise.enterpriseMember.otherMemberCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
              </el-row>
              <el-table
                :data="EnterpriseMemberMessageList"
                style="width: 98%"
                highlight-current-row
              >
                <el-table-column
                  type="index"
                  label="序号"
                  width="50"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="jobName"
                  label="职务"
                  min-width="20"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="姓名"
                  min-width="20"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="mobile"
                  label="联系方式"
                  width="60"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="memberIdentityName"
                  label="成员身份"
                  min-width="20"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="isPartyMember"
                  label="是否公共党员"
                  min-width="20"
                  align="center"
                  :formatter="formatterFn"
                >
                </el-table-column>
                <el-table-column
                  prop="contributionMoney"
                  label="出资额(万元)"
                  min-width="20"
                  align="center"
                >
                </el-table-column>
              </el-table>
            </div>
          </el-row>
      </el-tab-pane>
      <el-tab-pane name="4" label="财务状况">
        <el-row class="detail_item" :gutter="20">
            <div class="detail_name">资产及土地情况：</div>
            <div class="detail_content">
              <el-row
                type="flex"
                justify="space-between"
                class="detail_content-row"
              >
                <el-col :span="12"
                  ><div>
                    资产总额：{{
                      currentEnterprise.enterpriseAssetsLand.assetsMoney
                        | formatting("万元")
                    }}
                  </div></el-col
                >
                <el-col :span="12"
                  ><div>
                    固定资产净值：{{
                      currentEnterprise.enterpriseAssetsLand.fixedAssetsMoney
                        | formatting("万元")
                    }}
                  </div></el-col
                >
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                class="detail_content-row"
              >
                <el-col :span="12"
                  ><div>
                    总负债额：{{
                      currentEnterprise.enterpriseAssetsLand.totalLiabilities
                        | formatting("万元")
                    }}
                  </div></el-col
                >
                <el-col :span="12"
                  ><div>
                    所有者权益：{{
                      currentEnterprise.enterpriseAssetsLand.ownerAssets
                        | formatting("万元")
                    }}
                  </div></el-col
                >
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                class="detail_content-row"
              >
                <el-col :span="12"
                  ><div>
                    土地总面积：{{
                      currentEnterprise.enterpriseAssetsLand.landArea
                        | formatting("亩")
                    }}
                  </div></el-col
                >
                <el-col :span="12"
                  ><div>
                    土地经营权入股土地：{{
                      currentEnterprise.enterpriseAssetsLand.tdljyqLandArea
                        | formatting("亩")
                    }}
                  </div></el-col
                >
              </el-row>
                <el-row
                type="flex"
                justify="space-between"
                class="detail_content-row"
              >
                <el-col :span="12"
                  ><div>
                    流转土地：{{
                      currentEnterprise.enterpriseAssetsLand.outLandArea
                        | formatting("亩")
                    }}
                  </div></el-col
                >
                <el-col :span="12"
                  ><div>
                    其他土地：{{
                      currentEnterprise.enterpriseAssetsLand.otherLandArea
                        | formatting("亩")
                    }}
                  </div></el-col
                >
              </el-row>
            </div>
          </el-row>
         <el-row class="detail_item" :gutter="20">
            <div class="detail_name">收益及分配情况：</div>
            <div class="detail_content">
              <div class="detail_content-views">
                <div class="detail_content-views--block">
                  <h3>收益情况</h3>
                  <div class="boldView">
                    总收入：{{
                      currentEnterprise.enterpriseProfitAssignment.totalIncome
                        | formatting("万元")
                    }}
                  </div>
                  <div class="fineView">
                    其中年经营收入：{{
                      currentEnterprise.enterpriseProfitAssignment.yearIncome
                        | formatting("万元")
                    }}
                  </div>
                  <div class="boldView">
                    总支出：{{
                      currentEnterprise.enterpriseProfitAssignment.totalPay
                        | formatting("万元")
                    }}
                  </div>
                  <div class="fineView">
                    上年为分配盈余：{{
                      currentEnterprise.enterpriseProfitAssignment
                        .lastYearSurplus | formatting("万元")
                    }}
                  </div>
                  <div class="boldView">
                    总盈余：{{
                      currentEnterprise.enterpriseProfitAssignment.totalSurplus
                        | formatting("万元")
                    }}
                  </div>
                </div>
                <div class="detail_content-views--block">
                  <h3>分配情况</h3>
                  <div class="boldView">
                    年底分红总额：{{
                      currentEnterprise.enterpriseProfitAssignment
                        .yearEndObtainMoney | formatting("万元")
                    }}
                  </div>
                  <div class="fineView">
                    其中农民成员分红金额：{{
                      currentEnterprise.enterpriseProfitAssignment
                        .farmerObtainMoney | formatting("万元")
                    }}
                  </div>
                  <div class="boldView">
                    统一购买生产资料总额：{{
                      currentEnterprise.enterpriseProfitAssignment
                        .productionDataMoney | formatting("万元")
                    }}
                  </div>
                  <div class="boldView">
                    相对于散户优惠百分比：{{
                      currentEnterprise.enterpriseProfitAssignment
                        .productionDiscountPercentage | formatting("%")
                    }}
                  </div>
                  <div class="boldView">
                    统一组织销售农产品总额：{{
                      currentEnterprise.enterpriseProfitAssignment.saleMoney
                        | formatting("万元")
                    }}
                  </div>
                  <div class="boldView">
                    相对于散户优惠百分比：{{
                      currentEnterprise.enterpriseProfitAssignment
                        .saleDiscountPercentage | formatting("%")
                    }}
                  </div>
                </div>
                <div class="detail_content-views--block">
                  <h3>其他情况</h3>
                  <div class="boldView">
                    成员社内年平均所得收入：{{
                      currentEnterprise.enterpriseProfitAssignment.averageIncome
                        | formatting("万元")
                    }}
                  </div>
                  <div class="boldView">
                    财政直接补助财产是否平均量化到成员：{{
                      filterType(
                        currentEnterprise.enterpriseProfitAssignment
                          .subsidyIsAverage
                      )
                    }}
                  </div>
                  <div class="boldView">
                    公积金是否按章程规定量化到成员：{{
                      filterType(
                        currentEnterprise.enterpriseProfitAssignment
                          .accumulationFundIsAverage
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
          </el-row>
          <el-row class="detail_item" :gutter="20">
            <div class="detail_content">
              <div class="detail_content-row">
                <div class="detail_content-space">
                  <div class="half">
                    <div>年度资产负债表</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in assetsLiabilitie"
                        :key="key"
                      >
                      <el-image 
                         style="height: 100%;width: 100%;"
                          :src="item.url" 
                          :preview-src-list='[item.url]'>
                        </el-image>
                        <!-- <img :src="item.url" alt="" /> -->
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                            assetsLiabilitie
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
                <div class="detail_content-space">
                  <div class="half">
                    <div>盈余分配表</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in surplustList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                         <el-image 
                         style="height: 100%;width: 100%;"
                          :src="item.url" 
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                           surplustList
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="detail_content-row">
                <div class="detail_content-space">
                  <div class="half">
                    <div>成员权益变动表</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in ointerests"
                        :key="key"
                      >
                       <el-image 
                         style="height: 100%;width: 100%;"
                          :src="item.url" 
                          :preview-src-list='[item.url]'>
                        </el-image>
                        <!-- <img :src="item.url" alt="" /> -->
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                           interests
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-row>
      </el-tab-pane>
      <el-tab-pane name="5" label="贷款情况">
        <el-row class="detail_item" :gutter="20">
            <div class="detail_content">
              <div class="detail_content-row">
                今年是否贷款：{{
                  loanType(currentEnterprise.enterpriseLoan.isLoan)
                }}
              </div>
              <div class="detail_content-row">
                <el-row
                  type="flex"
                  justify="space-between"
                  style="width: 100%;height: 80px;"
                >
                  <el-col :span="6">
                    <div>贷款实际情况：</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="detail_content-row-top">贷款金额</div>
                    <div>
                      {{
                        currentEnterprise.enterpriseLoan.loanMoney
                          | formatting("万元")
                      }}
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="detail_content-row-top">贷款银行</div>
                    <div>
                      {{
                        currentEnterprise.enterpriseLoan.loanBank | formatting
                      }}
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="detail_content-row-top">贷款利率</div>
                    <div>
                      {{
                        currentEnterprise.enterpriseLoan.interestRate
                          | formatting("%")
                      }}
                    </div>
                  </el-col>
                </el-row>
                <el-row
                  type="flex"
                  justify="space-between"
                  style="width: 100%;height: 80px;"
                >
                  <el-col :span="6">
                    <div>贷款意向：</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="detail_content-row-top">贷款金额</div>
                    <div>
                      {{
                        currentEnterprise.enterpriseLoan.planLoanMoney
                          | formatting("万元")
                      }}
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="detail_content-row-top">贷款期限</div>
                    <div>
                      {{
                        currentEnterprise.enterpriseLoan.loanTerm | formatting
                      }}
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="detail_content-row-top">贷款用途</div>
                    <div>
                      {{
                        currentEnterprise.enterpriseLoan.loanPurpose
                          | formatting
                      }}
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-row>
      </el-tab-pane>
      <el-tab-pane name="6" label="制度章程">
        <el-row class="detail_item" :gutter="20">
            <div class="detail_content">
              <div class="detail_content-row">
                <div class="detail_content-space">
                  <div class="half">
                    <div>合作社章程</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .cooperativeCharterImgList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                         <el-image 
                         style="height: 100%;width: 100%;"
                          :src="item.url" 
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                            otherDetails.imgList.cooperativeCharterImgList
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
                <div class="detail_content-space">
                  <div class="half">
                    <div>合作社管理制度</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .manageRulesImgs"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                         <el-image 
                         style="height: 100%;width: 100%;"
                          :src="item.url" 
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                            otherDetails.imgList.cooperativeCharterImgList
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
                <div class="detail_content-space">
                  <div class="half">
                    <div>财务管理制度</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .financeRulesImgs"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                         <el-image 
                         style="height: 100%;width: 100%;"
                          :src="item.url" 
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                            otherDetails.imgList.financeRulesImgs
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
                <div class="detail_content-space">
                  <div class="half">
                    <div>质量管理制度</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .qualityAssuranceImgList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                         <el-image 
                         style="height: 100%;width: 100%;"
                          :src="item.url" 
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                            otherDetails.imgList.qualityAssuranceImgList
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
                <div class="detail_content-space">
                  <div class="half">
                    <div>质量安全追溯制度</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .qualitySafetyImgList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                         <el-image 
                         style="height: 100%;width: 100%;"
                          :src="item.url" 
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(otherDetails.imgList.qualitySafetyImgList)
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
                <div class="detail_content-space">
                  <div class="half">
                    <div>生产记录档案制度</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .styleDicNumbersImgList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                         <el-image 
                         style="height: 100%;width: 100%;"
                          :src="item.url" 
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(otherDetails.imgList.styleDicNumbersImgList)
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
                <div class="detail_content-space">
                  <div class="half">
                    <div>材料管理制度</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .materialManagementImgList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                         <el-image 
                         style="height: 100%;width: 100%;"
                          :src="item.url" 
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                            otherDetails.imgList.materialManagementImgList
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
                 <div class="detail_content-space">
                  <div class="half">
                    <div>其他</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .otherImgList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                         <el-image 
                         style="height: 100%;width: 100%;"
                          :src="item.url" 
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                            otherDetails.imgList.otherImgList
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-row>
      </el-tab-pane>
      <el-tab-pane name="7" label="运行绩效">
        <h3>参与政府项目</h3>
        <el-table
          :data="enterpriseGovernmentWorkList"
          style="width: 98%"
          highlight-current-row
        >
          <el-table-column
            type="index"
            label="序号"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="particularYear"
            label="年份"
            min-width="20"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="subsidyName"
            label="项目名称"
            min-width="20"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="subsidyMoney"
            label="补助金额(万元)"
            min-width="20"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="subsidyMoneyIsReceived"
            label="补助款是否到账"
            min-width="20"
            align="center"
            :formatter="formatterTypeFn"
          >
          </el-table-column>
        </el-table>
        <h3>社会贡献</h3>
        <el-table
            :data="societyContributVoList"
            style="width: 98%"
            highlight-current-row
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="year"
              label="年份"
              min-width="20"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="typeName"
              label="类别"
              min-width="20"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              min-width="20"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="describe"
              label="描述"
              min-width="20"
              align="center"
            >
            </el-table-column>
          </el-table>
      </el-tab-pane>
      <el-tab-pane name="8" label="荣誉贡献">
          <el-row type="flex" class="qualification-view qualification">
            <el-col :span="14"
              ><div class="left-space">荣誉资质类别</div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              个数(个/枚)</el-col
            >
            <el-col :span="5"><div class="center-space">附件</div></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"
              ><div class="left-space">拥有注册商标数</div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.brandCount | formatting("枚")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'brandCountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo.brandCountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"><div class="left-space">拥有专利数</div></el-col>
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.patentCount | formatting("个")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'patentCountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo.patentCountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"
              ><div class="left-space">拥有绿色食品认证数</div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.greenFoodCount | formatting("个")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'greenFoodCountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo.greenFoodCountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"
              ><div class="left-space">拥有有机产品认证数</div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.organiProductCount
                  | formatting("个")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'organiProductCountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo.organiProductCountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"
              ><div class="left-space">拥有地理标志产品认证数</div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.geographyProductCount
                  | formatting("个")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'geographyProductCountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo
                        .geographyProductCountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"
              ><div class="left-space">拥有食品生产许可证（CS）数</div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.csNcount | formatting("个")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'csNcountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo.csNcountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"
              ><div class="left-space">
                通过ISO9000,HACCP等质量认证情况
              </div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                filterType(otherDetails.enterpriseHonorVo.isIsoHaccp)
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, '--')"
                  :preview-src-list="[]"
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"><div class="left-space">其他</div></el-col>
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.otherCount | formatting("个")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'otherCountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo.otherCountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
      </el-tab-pane>
      <el-tab-pane name="9" label="场景照片">
        <el-row class="detail_item" :gutter="20">
            <div class="detail_content">
              <div class="detail_content-row">
                <div class="detail_content-space">
                  <div class="half">
                    <div>场景照片</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .sceneImgList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                         <el-image 
                         style="height: 100%;width: 100%;"
                          :src="item.url" 
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                            otherDetails.imgList.sceneImgList
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
               
              </div>
            </div>
          </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import API from "@/api/serviceOrgManagement/api_userManagement";
import gstbImg from "../../../static/img/gstb.png";
  export default {
    data(){
      return {
        activeValue: '1',
        gstbImg:gstbImg,
        tabPosition: 'right',
        currentEnterprise: {
          enterpriseProfitAssignment: {},
          enterpriseLoan: {},
          EnterpriseMemberMessageList: {},
          enterpriseMember: {},
          enterpriseAssetsLand: {},
          enterpriseManageItemVoList: [],
        }, //当前项字段
        spaceDetail:{},
        disabled:true,
         options: [
        {
          value: "2018",
          label: "2018",
        },
         {
          value: "2019",
          label: "2019",
        },
         {
          value: "2020",
          label: "2020",
        },
         {
          value: "2021",
          label: "2021",
        },
         {
          value: "2022",
          label: "2022",
        },
      ],
        otherDetails: {
          imgList: [],
          enterpriseHonorVo: {},
        }, // 其他项
        showDetailDialog: false,
        EnterpriseMemberMessageList: [], //组织成员情况 列表
        enterpriseGovernmentWorkList: [], // 参与政府项目
        societyContributVoList: [], // 社会贡献
        enterpriseNumber: "", //编号
        year: "2020",
        priseDetail: "",
        qualificationImg: "",//主体资格证明图片
        assetsLiabilitie:[],//负债
        surplustList:[],//盈余
        interests:[],//权益
      }
    },
    filters: {
      formatting(val, unit) {
        if (!val) {
          if (!unit) {
            return "--";
          }
          return 0 + unit;
        } else {
          return val + (unit ? unit : "");
        }
      },
    },
    created(){
      this.GLOBAL.eventBus.$on("selectEnterprise", this.dialogOpen)
    },
    methods:{
      formatterDate(cellValue) {
        if (!cellValue) {
          return "--";
        }
        return this.GLOBAL.timetoDate(Number(cellValue),'date');
      },
      showState(list) {
        if (list && list.length) {
          return false;
        }
        return true;
      },
      filterImgList(imgList) {
        // 过滤图片
        if (imgList && imgList.length) {
          let list = [];
          imgList.forEach((item) => {
            list.push(item.url);
          });
          return list;
        }
        return [];
      },
      showIcon(current, list) {
        if (
          current.enterpriseHonorVo &&
          current.enterpriseHonorVo[list] &&
          current.enterpriseHonorVo[list].length
        ) {
          return require("../../../static/img/attachment.png");
        } else {
          return require("../../../static/img/ashAttachment.png");
        }
      },
      loanType(val) {
        if (val === 2) {
          return "否";
        } else if (val === 1) {
          return "是";
        }
        return "--";
      },
      filterType(val) {
        if (val === 0) {
          return "否";
        } else if (val === 1) {
          return "是";
        }
        return "--";
      },
      formatterFn(row, column, cellValue, index) {
        if (cellValue === 2) {
          return "否";
        } else if (cellValue === 1) {
          return "是";
        }
        return "--";
      },
      formatterTypeFn(row, column, cellValue, index) {
        if (cellValue === 0) {
          return "否";
        } else if (cellValue === 1) {
          return "是";
        }
        return "--";
      },
      handleClick(){
        if(this.activeValue==2){
            this.disabled=false
        }else if(this.activeValue==3){
            this.disabled=false
        }else if(this.activeValue==4){
            this.disabled=false
        }else if(this.activeValue==5){
            this.disabled=false
        }else{
          this.disabled=true
        }
       
      },
      selectYear(val) {
        this.year=val
        this.manageDetail()
    },
      // 打开详情弹窗
      dialogOpen(number,year) {
        this.showDetailDialog = true;
        this.currentEnterprise.enterpriseProfitAssignment = {};
        this.currentEnterprise.enterpriseLoan = {};
        this.currentEnterprise.enterpriseMember = {};
        this.currentEnterprise.enterpriseAssetsLand = {};
        this.currentEnterprise.enterpriseManageItemVoList = [];
        this.EnterpriseMemberMessageList = []; //组织成员情况 列表
        this.enterpriseGovernmentWorkList = []; // 参与政府项目
        this.societyContributVoList = []; // 社会贡献
        this.enterpriseNumber = number;
        // 
        console.log("year",year)
        if(year==0 || year==undefined){
          this.year='2020'   
        }else{
          this.year=year.toString()
        }
        this.getPriseDetail(number);
        this.manageDetail(number);
        this.restDetail(number);
      },
      // handleClick() {},
      // 查询当前打开项
      async manageDetail(enterpriseNumber) {
        const { code, data, msg } = await API.manageDetail({
          enterpriseNumber: enterpriseNumber||this.enterpriseNumber,
          year: this.year,
        });
        if (code === 0) {
          this.currentEnterprise = data;
          this.EnterpriseMemberMessageList = data.EnterpriseMemberMessageList; //组织成员列表
          // 3:年度资产负债，4：盈余分配表，5：成员权益变动表
        this.assetsLiabilitie=[]
        this.surplustList=[]
        this.interests=[]
        if(data.financeImgList.length!=0){
          data.financeImgList.map(item=>{
            if(item.type==3){
                this.assetsLiabilitie.push(item)
            }else if(item.type==4){
                this.surplustList.push(item)
            }else{
              this.interests.push(item)
            }
          })

        }
        } else {
          this.GLOBAL.warning("暂无年度上报信息");
        }
      },
      async restDetail(enterpriseNumber) {
        const { code, data } = await API.restDetail({
          enterpriseNumber,
        });
        if (code === 0) {
          this.otherDetails = data;
          this.enterpriseGovernmentWorkList = data.enterpriseGovernmentWorkList;
          this.societyContributVoList = data.societyContributVoList;
        } else {
          this.GLOBAL.error(msg);
        }
      },
      async getPriseDetail(number) {
        const { code, data, msg } = await API.priseDetail({ number });
        if (code === 0) {
          this.spaceDetail = data.UnauditedList;
          this.spaceDetail.enterpriseImgList.forEach((item) => {
            if (item.type === 1) {
              this.qualificationImg = item.url;
            } else if (item.type === 4) {
              this.licenseImg = item.url;
            }
          });
        } else {
          this.GLOBAL.error(msg);
        }
      },
    }
  }
</script>
<style lang="less" scoped>
/deep/  .el-input--suffix .el-input__inner {
    height: 32px;}
</style>

<style lang="less">
.detail_board_container{
  width: 100%;
  height: calc(100% - 36px);
  padding: 10px;
  box-sizing: border-box;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  .el-tabs__nav{
    transform: translateY(0) !important;
  }
  .el-tabs__content{
    height: 100%;
    .el-tab-pane{
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
  .qualification-view {
    padding: 13px 10px;
    width: 98%;
    .left-space {
      padding-left: 10px;
    }
    .center-space {
      text-align: center;
    }
  }
  .qualification {
    background: #f8f8f8;
    color: #909399;
    font-weight: bold;
  }
  .space-top {
    margin-top: 10px;
  }
    .management_dialog-select {
      position: absolute;
      right: 100px;
      top: 3px;
      width: 90px;
      z-index: 1;
      height: 32px;
    }
    .detail_item {
      padding: 0 10px 0 20px;
      .detail_content-row {
        padding: 10px 0;
        .detail_content-space {
          display: flex;
          justify-content: space-between;
          .half {
            width: 96%;
            > div:nth-child(1) {
              margin-top: 10px;
            }
          }
        }
        .detail_content-row-images {
          // display: flex;
          padding: 10px;
          height: 102px;
          background: #f5f8fb;
          // justify-content: space-between;
          margin-top: 10px;
          display: -webkit-box;
          overflow: auto;
          .allThe {
            width: 100%;
          }
          div {
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32%;
             /deep/.el-image {
                height: 100% !important;
                width: 100%  !important;
              }
          }
        }
        .detail_content-row-top {
          width: 100%;
          height: 32px;
          line-height: 32px;
          text-align: center;
          margin-top: -7px;
          background: #f5f8fb;
        }
        .detail_content-row-top + div {
          width: 100%;
          text-align: center;
          padding: 10px 0 0;
        }
      }
      .detail_name {
        
        color: #0dc98e;
        font-weight: bold;
      }
      .detail_content-views {
        margin-top: 19px;
        .detail_content-views--block {
          padding-top: 2px;
          margin-top: 12px;
          width: 92%;
          background: #f5f8fb;
          height: 286px;
          .boldView {
            font-weight: bold;
            margin: 15px 0 0 20px;
          }
          .fineView {
            color: #d0d2cb;
            margin: 15px 0 0 30px;
          }
          h3 {
            text-align: center;
          }
        }
      }
  }
  .info-detail {
  padding-left: 10px;
  .info-detail-block {
    padding-bottom: 15px;
    display: flex;
    .location-svg {
      height: 18px;
      width: 12px;
      margin-left: 10px;
      cursor: pointer;
    }
    .info-detail-block-license {
      width: 200px;
      margin-top: 5px;
      // height: 197px;
    }
    .info-detail-block-openImg {
      width: 200px;
      // width: 138px;
    }
  }
}
.info-detail-block-img {
  width: 247px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
}
/deep/ #select {
    height: 32px;
}
</style>


// WEBPACK FOOTER //
// src/studio/oneMap/detailBorad.vue